<template>
  <div class="topbar-slide-temp" :class="{ 'hide-for-countdown': !showTopBar }">
    <div style="max-width: 100%; width: 100%;">
      <swiper
        :slidesPerView="1"
        :modules="modules"
        class="main-swiper"
        :class="{'custom_announcement': data.length == 1}"
        :navigation="{
          nextEl: '.swiper-button-next-list',
          prevEl: '.swiper-button-prev-list',
        }"
        :loop="true"
        :autoplay="{
          delay: 3000,
          disableOnInteraction: false,
        }"
      >
        <swiper-slide style="width: 100%"  v-for="(item, index) in data" :key="index">
         
          <a v-if="item.link.url && !props.check_cny" :href="getLangUrl(item.link?.url, baseUrl, locale)" class="topbar-link">{{ htmlSpecialcharsDecode(item.text) }}</a>
          <a v-else-if="item.link.url && props.check_cny" @click.prevent="loadingAtcCny" href="/cny" class="topbar-link">{{ htmlSpecialcharsDecode(item.text) }}</a>
          <span v-else class="topbar-link" >{{ htmlSpecialcharsDecode(item.text) }}</span>
        </swiper-slide>
        <!-- <swiper-slide v-else >
         
          <a class="topbar-link">{{ htmlSpecialcharsDecode(data[0].text) }}</a>
          
        </swiper-slide> -->
        
      </swiper>
      <!-- {{ announcements[0]?.text }} -->
      <div
        v-show="showClose"
        @click="announcementClose"
        class="announcement-bar-close"
      >
        +
      </div>
      <div v-show="showBox" class="box-controls">
        <div class="box-btn">
          <div v-show="isShowPrev" class="main-swiper swiper-button-prev-list">
            <svg
              style="width: 20px; height: 20px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 256 512"
            >
              <path
                d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"
                fill="white"
              ></path>
            </svg>
          </div>
        </div>
        <div class="box-btn">
          <div v-show="isShowNext" class="main-swiper swiper-button-next-list">
            <svg
              style="width: 20px; height: 20px"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 256 512"
            >
              <path
                d="M246.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-160 160c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 41.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l160 160z"
                fill="white"
              ></path>
            </svg>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation,Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import { ref, onMounted, onBeforeUnmount, nextTick } from "vue";
import {setCookie} from '@/utils/cookie';
const isShowNext = ref(true);
const isShowPrev = ref(true);
const showTopBar = ref(true);
const showClose = ref(false);
const showBox = ref(true);
const announcements = ref([]);
const loading_cny = ref(false);
const router = useRouter();
const route = useRoute();
const runtimeConfig = useRuntimeConfig();
import { useI18n } from 'vue-i18n';
const { locale } = useI18n();
import { getLangUrl } from '~/utils/getLangUrl';
const baseUrl = runtimeConfig.public.BASE_URL;

const props = defineProps({
  data: Array,
  check_cny: Boolean,
});
const emit = defineEmits(["loading-cny"]);

// const onThumbsChange = (swiper) => {
//   isShowPrev.value = !swiper.isBeginning;
//   isShowNext.value = !swiper.isEnd;
// };

const announcementClose = () => {
  showTopBar.value = false;
  setCookie('topbarClosed', 'false', 1);
};

const loadingAtcCny = () => {
  console.log('xxxxxx');

  loading_cny.value = true;
  emit('loading-cny', true);
  // Set cookie
  const pageElement = document.getElementById('page');
  if (pageElement) {
    pageElement.style.top = '0px';
  }
  
  let cnyUrl = '/cny';
   
   setTimeout(() => {
      router.push(cnyUrl);
   }, 800);
}

const handleResize = () => {
  showClose.value = window.innerWidth < 1020;
  showBox.value = window.innerWidth >= 768;
};

onMounted(() => {
  if (props.data && props.data.length) {

      announcements.value = props.data;
    
  }

  handleResize();
  window.addEventListener("resize", handleResize);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", handleResize);
});

const modules = [Navigation,Autoplay];
</script>

  
  <style lang="scss" >
@import "~/assets/scss/components/top-bar/_slide-temp.scss";
.swiper-wrapper{
align-items: center !important;
}
</style>
  